import React from "react";
import Map from "./components/Map";

const App: React.FC = () => {
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <Map />
    </div>
  );
};

export default App;
